import type { AuthSession, Session } from './session';

export function isAtLeastIdentified(session: Session): session is AuthSession {
	return session.loginState !== 'GUEST';
}
